import { Defaults } from "../../defaults";
import moment from 'moment';
import "../../lib/accent-neutralise";
moment.locale('es');
export class Confirmar {
    confirmarAsistencia() {
    }
    rechazarAsistencia() {
    }
    initDatatable() {
        const filename = 'Boda * - Lista de Invitados';
        Confirmar.table = $('table').DataTable({
            dom: '<"row"<"col-2"B><"col"f>>rtip',
            buttons: [
                {
                    title: filename,
                    // @ts-ignore
                    messageTop: `Fecha: ${moment().format('DD/MMMM/YYYY hh:mma')}\r\n`,
                    extend: 'pdfHtml5',
                    exportOptions: {
                        columns: [0, 2, 3, 4, 5],
                        orthogonal: "export",
                        modifier: {
                            order: 'index'
                        }
                    },
                    orientation: 'portrait',
                    filename,
                    // @ts-ignore
                    download: 'open',
                }
            ],
            stateSave: false,
            order: [[4, 'desc']],
            ajax: {
                url: 'guest/list',
                dataSrc: Defaults.global.dt.ajax.dataSrc('invites')
            },
            initComplete(settings, response) {
                const totals = response.data.invites.reduce((a, b) => {
                    return {
                        invites: a.invites + b.invites,
                        confirmed: a.confirmed + b.confirmed,
                        side: '',
                    };
                });
                $("#txtTotal").text(totals.invites);
                $("#txtConfirmados").text(totals.confirmed);
                $("#txtNovio").text(response.data.totales.novio.total);
                $("#txtNovia").text(response.data.totales.novia.total);
                $("#txtNovioC").text(response.data.totales.novio.confirmados);
                $("#txtNoviaC").text(response.data.totales.novia.confirmados);
            },
            columnDefs: Defaults.global.dt.getColumns([
                {
                    title: 'Invitación',
                    data: 'name',
                    render(data, type, { id }) {
                        if (type == 'display') {
                            const code = btoa(id);
                            return `<a href="../?id=${code}" target="_blank" class="btn" style="padding-top: 0; padding-bottom:0;">${data}</a>`;
                        }
                        return data;
                    }
                },
                {
                    title: 'Invitados',
                    data: 'guests',
                },
                {
                    title: 'Lado',
                    data: 'side'
                },
                {
                    title: 'Contacto',
                    data: 'phone',
                    render(data, type, { id }) {
                        if (type === 'display' || type === "filter") {
                            if (!data) {
                                data = 'Sin Teléfono';
                            }
                            return `<div style="width: max-content">`
                                + `<button onclick="btnChangePhone(${id})" class="btn btn-sm" style="padding-top: 0; padding-bottom:0;">${data}</button>`
                                + `</div>`;
                        }
                        if (type === "export") {
                            return data;
                        }
                        return data;
                    }
                },
                {
                    title: 'Cuenta',
                    data: 'invites',
                },
                {
                    title: 'Confirmados',
                    data: 'confirmed',
                    render(data, type, { id }) {
                        if (type == 'display') {
                            const code = btoa(id);
                            const message = data == null ? 'No ha confirmado' : data == 0 ? 'Rechazó asistencia' : data;
                            return `<a href="../confirmar?id=${code}" target="_blank" class="btn btn-sm" style="padding-top: 0; padding-bottom:0;">${message}</a>`;
                        }
                        if (type === "export") {
                            const message = data == null ? '' : data == 0 ? 'Rechazó asistencia' : data;
                            return `${message}`;
                        }
                        return data;
                    }
                },
                {
                    title: 'Invitación Enviada',
                    data: 'sent',
                    render(data, type, { id, confirmed }) {
                        if (type === 'display') {
                            return `<div style="width: max-content">`
                                + ((data || confirmed != null) ? 'Sí' : `<button onclick="btnInviteSent(${id})" class="btn btn-sm" style="padding-top: 0; padding-bottom:0;">No</button>`)
                                + `</div>`;
                        }
                        if (type === "export") {
                            return '';
                        }
                        return (data || confirmed != null);
                    }
                },
                {
                    title: 'Acciones',
                    data: null,
                    render(data, type, { id, phone }) {
                        const code = btoa(id);
                        const message = encodeURIComponent(Defaults.global.publicUrl + `/?id=${code}`);
                        const qr = encodeURIComponent(`https://chart.googleapis.com/chart?cht=qr&chs=500x500&choe=UTF-8&chld=H%7C4&chl=${Defaults.global.publicUrl + '/invitado?i=' + code}`);
                        return `<div style="width: max-content">`
                            + (phone ? `<a href="tel:${phone}" class="btn btn-sm" style="padding:8px;"><i class="material-icons">phone</i></a>` : '')
                            + (phone ? `<a href="https://wa.me/52${phone}?text=${message}" target="_blank" class="btn btn-sm" style="padding:4px 5px;zoom:2;"><i class="fab fa-whatsapp"></i></a>` : '')
                            + (phone ? `<a href="https://wa.me/52${phone}?text=${qr}" target="_blank" class="btn btn-sm" style="padding:4px 5px;zoom:2;"><i class="fas fa-qrcode"></i></a>` : '')
                            + `</div>`;
                    }
                }
            ])
        });
    }
    static btnChangePhone(id) {
        const phone = prompt('Ingrese un teléfono');
        if (!phone) {
            return;
        }
        $.ajax({
            url: 'invite/phone',
            method: 'put',
            data: { id, phone }
        }).done(() => {
            Confirmar.table.ajax.reload();
        });
    }
    static btnInviteSent(id) {
        if (!confirm('Desea confirmar que ya envió la invitacion seleccionada?')) {
            return;
        }
        $.ajax({
            url: 'invite/sent',
            method: 'put',
            data: { id }
        }).done(() => {
            Confirmar.table.ajax.reload();
        });
    }
}
window['btnChangePhone'] = Confirmar.btnChangePhone;
window['btnInviteSent'] = Confirmar.btnInviteSent;
